import Select from "react-select"
import React, {Fragment, useEffect} from "react"
import {
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Input,
    Form,
    CardTitle,
    Label,
} from "reactstrap"

export const Filter = props => {
    const {
        setFrom,
        setTo,
        // setItem,
        setType
    } = props

    useEffect(() => {
        props.call()
    }, [props.item])
    return (
        <Fragment>
            <Card>
                <CardBody>
                    <CardTitle className="mb-4"></CardTitle>

                    <Row>
                        <Col lg={3}>
                            <div className="row mb-4">
                                <Label
                                    htmlFor="horizontal-firstname-Input"
                                    className="col-sm-3 col-form-label"
                                >
                                    From
                                </Label>
                                <Col sm={9}>
                                    <Input
                                        onChange={e => setFrom(e.target.value)}
                                        type="date"
                                        className="form-control"
                                        id="horizontal-firstname-Input"
                                    />
                                </Col>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="row mb-4">
                                <Label
                                    htmlFor="horizontal-email-Input"
                                    className="col-sm-3 col-form-label"
                                >
                                    To
                                </Label>
                                <Col sm={9}>
                                    <Input
                                        onChange={e => setTo(e.target.value)}
                                        type="date"
                                        className="form-control"
                                        id="horizontal-email-Input"
                                    />
                                </Col>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="row mb-4">
                                <Label
                                    htmlFor="horizontal-email-Input"
                                    className="col-sm-3 col-form-label"
                                >
                                    Type
                                </Label>
                                <Col sm={9}>
                                    <select
                                        className="form-control"
                                        onChange={e => {
                                            setType(e.target.value)
                                        }}
                                    >
                                        <option value="all">All</option>
                                        <option value="pending">Pending</option>
                                        <option value="won">Won</option>
                                        <option value="lost">Lost</option>
                                    </select>
                                </Col>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="row mb-4">
                                <Label
                                    htmlFor="horizontal-email-Input"
                                    className="col-sm-3 col-form-label"
                                >
                                    Type
                                </Label>
                                <Col sm={9}>
                                    <select
                                        className="form-control"
                                        onChange={e => {
                                            props.setItem(e.target.value)
                                        }}
                                    >
                                        <option value="Sports">Sports</option>
                                        <option value="Pragmatic">Pragmatic Games</option>
                                        <option value="Turbo">Turbo Games</option>
                                        <option value="Spribe">Spribe Games</option>
                                        <option value="Bigwins">BigWins</option>
                                    </select>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <div className="row" style={{float:'right'}}>
                                <div>
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            props.call()
                                        }}
                                        color="primary"
                                        className="w-md"
                                    >
                                        Search
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    )
}